export default "__VITE_ASSET__DVzV3hHI__"